import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {InsoleCadProcessModel} from "../../../api/model/insoleCadProcess.model";

@Injectable({
    providedIn: 'root'
})
export class InsoleCadProcessRepository extends AbstractRepositoryV2<InsoleCadProcessModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('InsoleCadProcess', serviceElementsFactory, injector);
    }
}
